import { createSlice } from '@reduxjs/toolkit';

interface ILanguageState {
	language: string;
}
const initialState: ILanguageState = {
	language: 'ru',
};

export const languageSlice = createSlice({
	name: 'languages',
	initialState,
	reducers: {
		setLang: (state, action) => {
			state.language = action.payload;
		},
	}
});

export const { setLang } = languageSlice.actions;
export default languageSlice.reducer;
